/**
 * 编辑车辆诊断运维备注
 */
import React, {useState, useEffect} from "react";
import {Modal, Form, message, Input, Select, Switch} from "antd";
import {
  updateCarOperatingStatusRequest,
  upsetOperateContentRequests,
  updateVehicleCoordinateAbilityRequests,
  upsertCarRequest
} from "@/service/carManage";

interface AssignModalProps {
  data: any; // 工单信息
  type: string; // 操作类型(指派/重新指派)
  onClose: () => void; // 关闭弹窗的方法
  onOk: (values?: any) => void; // 确认弹窗后触发的方法
}

const coordinateAbilityOptions = [
  {label: '配合', value: '配合'},
  {label: '一般配合', value: '一般配合'},
  {label: '完全不配合', value: '完全不配合'}
]

const SPECIAL_OPERATING_STATUS = '特殊情况';

const operatingStatusOptions = [
  {label: '拆除', value: '拆除'},
  {label: '报废', value: '报废'},
  {label: '诉讼', value: '诉讼'},
  {label: '卖车', value: '卖车'},
  {label: '保密单位', value: '保密单位'},
  {label: '报停', value: '报停'},
  {label: '市场协助', value: '市场协助'},
  {label: '发函', value: '发函'},
  {label: SPECIAL_OPERATING_STATUS, value: SPECIAL_OPERATING_STATUS},
]

const getOperatingStatusFormValue = (operatingStatus?: string) => {
  if (!operatingStatus) {
    return {
      operatingStatus: undefined,
      customOperatingStatus: undefined,
    };
  }

  const isPresetStatus = operatingStatusOptions.some(item => item.value === operatingStatus);

  return {
    operatingStatus: isPresetStatus ? operatingStatus : SPECIAL_OPERATING_STATUS,
    customOperatingStatus: isPresetStatus ? undefined : operatingStatus,
  };
};

const EditServiceState = (props: AssignModalProps) => {
  const {data, onClose, onOk, type} = props;
  const [loading, setLoading] = useState<boolean>(false); // 提交接口是否请求中
  const [form] = Form.useForm();
  const [submitNoRepetition, setSubmitNoRepetition] = useState(true); // 不能重复请求

  useEffect(() => {
    const oldValue = {
      content: data.operateRemark,
      coordinateAbility: data.coordinateAbility,
      isConfirmed: data.confirmInfoFlag === 1,
      ...getOperatingStatusFormValue(data.operatingStatus)
    };
    form.setFieldsValue(oldValue);
  }, []);

  // 编辑请求
  const submit = async (values: any) => {
    if (submitNoRepetition) {
      setSubmitNoRepetition(false);
      setLoading(true);
      try {
        // 是否已确认 - 调用 /api/v2/car/upsert，仅传 id 和 confirmInfoFlag
        if (type === 'isConfirmed') {
          const res = await upsertCarRequest({
            id: data.carId,
            confirmInfoFlag: values.isConfirmed ? 1 : 0
          });
          if (res.data?.code === 0 || res.data?.success) {
            message.success("修改成功");
            onClose();
            onOk();
          }
          return;
        }
        let params: any = {
          content: values.content,
          carId: data.carId,
          id: data.carId,
          coordinateAbility: values.coordinateAbility
        };
        let url = type === 'coordinateAbility' ? updateVehicleCoordinateAbilityRequests : upsetOperateContentRequests
        if (type === 'operatingStatus') {
          const operatingStatus = values.operatingStatus === SPECIAL_OPERATING_STATUS
            ? values.customOperatingStatus || SPECIAL_OPERATING_STATUS
            : values.operatingStatus;

          params = {operatingStatus};
          url = (params: any) => updateCarOperatingStatusRequest(data.carId, params);
        }
        const res = await url(params);
        if (res.data?.code === 0 || res.data?.success) {
          message.success("修改成功");
          onClose();
          onOk();
        }
      } catch (error) {
      } finally {
        setLoading(false);
        setSubmitNoRepetition(true);
      }
    }
  };

  const titleMap: any = {
    editServiceState: "服务备注",
    coordinateAbility: "客户配合度",
    operatingStatus: "车辆运营状态",
    isConfirmed: "是否已确认"
  };

  return (
    <Modal title={titleMap[type] || "服务备注"} visible centered
           onCancel={() => {
             onClose()
             form.resetFields()
           }}
           onOk={
             () => {
               form.submit()
             }
           }
           okButtonProps={{loading}} maskClosable={false} width={type === 'operatingStatus' ? 420 : 580}>
      <Form form={form} autoComplete="off" layout="vertical" scrollToFirstError onFinish={submit}>
        {type === 'editServiceState' && <Form.Item label="" name="content">
          <Input.TextArea placeholder="请输入服务备注" allowClear/>
        </Form.Item>}
        {type === 'coordinateAbility' && <Form.Item label="客户配合度" name="coordinateAbility">
          <Select placeholder="请选择用户配合度" allowClear options={coordinateAbilityOptions}>
            
          </Select>
        </Form.Item>}
        {type === 'operatingStatus' && <Form.Item label="车辆运营状态" name="operatingStatus">
          <Select
            placeholder="请选择车辆运营状态"
            allowClear
            options={operatingStatusOptions}
            onChange={(value) => {
              if (value !== SPECIAL_OPERATING_STATUS) {
                form.setFieldsValue({customOperatingStatus: undefined});
              }
            }}
          />
        </Form.Item>}
        {type === 'operatingStatus' && (
          <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.operatingStatus !== currentValues.operatingStatus}>
            {({getFieldValue}) => getFieldValue('operatingStatus') === SPECIAL_OPERATING_STATUS ? (
              <Form.Item label="特殊情况说明" name="customOperatingStatus">
                <Input placeholder="请输入特殊情况说明" allowClear/>
              </Form.Item>
            ) : null}
          </Form.Item>
        )}
        {type === 'isConfirmed' && (
          <Form.Item label="是否已确认" name="isConfirmed" valuePropName="checked">
            <Switch checkedChildren="是" unCheckedChildren="否" />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default EditServiceState;
